var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81738 7.88672C4.44629 7.88672 3.37988 6.79492 3.37988 5.44922C3.37988 4.10352 4.44629 3.01172 5.81738 3.01172C7.16309 3.01172 8.25488 4.10352 8.25488 5.44922C8.25488 6.79492 7.16309 7.88672 5.81738 7.88672ZM10.6924 10.3242H5.81738C3.10059 10.3242 0.942383 8.14062 0.942383 5.44922C0.942383 2.75781 3.10059 0.574219 5.81738 0.574219H10.6924C13.3838 0.574219 15.5674 2.75781 15.5674 5.44922C15.5674 8.14062 13.3838 10.3242 10.6924 10.3242ZM10.6924 2.19922H5.81738C4.01465 2.19922 2.56738 3.67188 2.56738 5.44922C2.56738 7.25195 4.01465 8.69922 5.81738 8.69922H10.6924C12.4697 8.69922 13.9424 7.25195 13.9424 5.44922C13.9424 3.67188 12.4697 2.19922 10.6924 2.19922Z",
    fill: "#1956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggle);
export default __webpack_public_path__ + "static/media/icon_toggle.e045c8aad39517bf4ebbac4507287010.svg";
export { ForwardRef as ReactComponent };